import { getCoreFollowedAllSlice } from './get';

export const {
	receiveGetCoreFollowedAll,
	requestGetCoreFollowedAll,
	resetGetCoreFollowedAll
} = getCoreFollowedAllSlice.asyncActionCreators;
